import { gql } from '../../__generated__/gql'

export const COMMUNITY_TOGGLE_PIN_POST_MUTATION = gql(`
    mutation togglePinPost( $postId: Int! ) {
      togglePinPost(input: { postId: $postId }) {
        communityPost {
          id
          pinned
        }
      }
    }
`)
